<mat-card class="panel-card no-shadow">
  <mat-card-header class="panel-header">
    <mat-card-title class="panel-title card-title">
      <span class="panel-title-text">
        {{teams.length > 1 ? ('teams' | translate) : ('step51_team' | translate) + ' ' + (selectedTeam?.name || '')}}
      </span>
      <span *ngIf="showMembersWarning" class="tip members-warning">
        <i class="bi bi-question-circle-fill me-1 text-warning"></i>{{'step51_note' | translate}}
      </span>
    </mat-card-title>

    <div class="organize-teams-carousel" *ngIf="teams.length > 1">
      <p-carousel [value]="teams" [numVisible]="3" [numScroll]="3" [circular]="true"
                  [responsiveOptions]="carouselResponsiveOptions">
        <ng-template let-team pTemplate="item">
          <div class="product-item" [class.product-item--selected]="team.uuid === selectedTeam?.uuid">
            <span class="p-badge-info badge-check" *ngIf="team.memberCount >= minMembersForFeedback">
              <img src="assets/svg/check.svg" alt="">
            </span>
            <span class="p-badge-info badge-warning leader-pulse"
                  *ngIf="team.memberCount > 0 && team.memberCount < minMembersForFeedback">
              <img src="assets/svg/triangle-alert.svg" alt="" tooltipStyleClass="tooltip-style"
                   [pTooltip]="'step51_note' | translate">
            </span>

            <div class="team-button" role="button" tabindex="0"
                 [class.team-button--selected]="team.uuid === selectedTeam?.uuid"
                 (click)="selectTeam.emit(team.uuid)" (keydown.enter)="selectTeam.emit(team.uuid)"
                 [pTooltip]="team.name" tooltipPosition="bottom" tooltipStyleClass="tooltip-style">
              <span class="team-initial">{{team.initial}}</span>
              <p class="carousel-team-name">{{team.name}}</p>
              <span *ngIf="team.loadState === 'pending'"
                    class="spinner-border spinner-border-sm team-state-icon" role="status"></span>
              <button *ngIf="team.loadState === 'error'" type="button" class="team-retry-button"
                      [attr.aria-label]="'organizeteam_team_load_error' | translate"
                      [pTooltip]="'organizeteam_team_load_error' | translate" tooltipPosition="bottom"
                      tooltipStyleClass="tooltip-style" (click)="onRetry($event, team.uuid)">
                <i class="bi bi-arrow-clockwise"></i>
              </button>
              <img *ngIf="team.loadState === 'loaded' && team.teamType" class="team-type-icon"
                   [src]="'assets/svg/team-' + team.teamType.slug + '.svg'" alt=""
                   [pTooltip]="team.teamType.title | titlecase" tooltipPosition="bottom" tooltipStyleClass="tooltip-style">
            </div>
          </div>
        </ng-template>
      </p-carousel>
    </div>
  </mat-card-header>

  <mat-card-content class="panel-content">
    <div class="team-state" *ngIf="selectedTeam?.loadState === 'pending'">
      <span class="spinner-border text-primary" role="status"></span>
    </div>
    <div class="team-state" *ngIf="selectedTeam?.loadState === 'error' && selectedTeam as team">
      <p>{{'organizeteam_team_load_error' | translate}}</p>
      <button type="button" class="btn btn-hallow" (click)="onRetry($event, team.uuid)">
        {{'organizeteam_retry' | translate}}
      </button>
    </div>

    <ng-container *ngIf="selectedTeam?.loadState === 'loaded'">
      <mat-card class="role-card" [ngClass]="leaders.length === 0 ? 'leader-pulse' : 'no-shadow'">
        <mat-card-header class="role-header leader-header">
          <mat-card-title class="card-title">
            <img class="role-icon" src="assets/svg/crown.svg" alt="">{{'organizeteam_leaders' | translate}}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content class="role-content leader-card">
          <div cdkDropList
               id="leaders"
               class="role-list"
               [cdkDropListData]="leaders"
               [cdkDropListConnectedTo]="['members']"
               (cdkDropListDropped)="onDropped($event)">
            <div *ngFor="let member of leaders; trackBy: trackByUser" cdkDrag [cdkDragData]="member"
                 class="team-person team-leader">
              <div class="team-person-info">
                <img class="user-picture" [src]="member.avatarUrl || defaultAvatar" alt="">
                <p class="member-label" [title]="member.label">{{member.label}}</p>
              </div>
              <button type="button" class="delete-button" [attr.aria-label]="'organizeteam_remove_member' | translate"
                      (click)="onRemove(member, 'leader')">
                <img src="assets/svg/team-delete-button.svg" alt="">
              </button>
            </div>
            <div class="role-add team-leader-add">{{'step51_leaders_text' | translate}}</div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="role-card" [ngClass]="members.length === 0 ? 'member-pulse' : 'no-shadow'">
        <mat-card-header class="role-header member-header">
          <mat-card-title class="card-title">
            <img class="role-icon" src="assets/svg/user.svg" alt="">{{'step51_team_members' | translate}}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content class="role-content member-card">
          <div cdkDropList
               id="members"
               class="role-list"
               [cdkDropListData]="members"
               [cdkDropListConnectedTo]="['leaders']"
               (cdkDropListDropped)="onDropped($event)">
            <div *ngFor="let member of members; trackBy: trackByUser" cdkDrag [cdkDragData]="member"
                 class="team-person team-member">
              <div class="team-person-info">
                <img class="user-picture" [src]="member.avatarUrl || defaultAvatar" alt="">
                <p class="member-label" [title]="member.label">{{member.label}}</p>
              </div>
              <button type="button" class="delete-button" [attr.aria-label]="'organizeteam_remove_member' | translate"
                      (click)="onRemove(member, 'member')">
                <img src="assets/svg/team-delete-button.svg" alt="">
              </button>
            </div>
            <div class="role-add team-member-add">{{'step51_drag_text' | translate}}</div>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </mat-card-content>
</mat-card>
